import api from "./api";
import { GetRemessasDto } from "../shared/dtos/Remessa.dto";
import { StatusRemessa } from "../shared/enum/remessas.enum";
import { ResultDto } from "../shared/dtos/Result.dto";

class RemessasService {
  static async getByStatus(
    status: StatusRemessa,
    page: number,
    take: number
  ): Promise<{ data: GetRemessasDto[]; total: number }> {
    try {
      const response = await api.get(
        `remessas/get-by-status/${status}/${page}/${take}`
      );

      return response.data as { data: GetRemessasDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar as remessas:", error);
      return { data: [], total: 0 };
    }
  }

  static async getByStatusAndSearch(
    status: StatusRemessa,
    search: string,
    page: number,
    take: number
  ): Promise<{ data: GetRemessasDto[]; total: number }> {
    try {
      const response = await api.get(
        `remessas/get-by-status-search/${status}/${search}/${page}/${take}`
      );

      return response.data as { data: GetRemessasDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar as remessas::", error);
      return { data: [], total: 0 };
    }
  }

  static async getBySearch(
    search: string,
    page: number,
    take: number
  ): Promise<{ data: GetRemessasDto[]; total: number }> {
    try {
      const response = await api.get(
        `remessas/get-by-search/${search}/${page}/${take}`
      );

      return response.data as { data: GetRemessasDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar as remessas::", error);
      return { data: [], total: 0 };
    }
  }

  static async getAll(
    page: number,
    take: number
  ): Promise<{ data: GetRemessasDto[]; total: number }> {
    try {
      const response = await api.get(`remessas/get-all/${page}/${take}`);

      return response.data as { data: GetRemessasDto[]; total: number };
    } catch (error) {
      console.error("Erro ao buscar as remessas::", error);
      return { data: [], total: 0 };
    }
  }

  static async updateStatus(
    id: number,
    status: StatusRemessa
  ): Promise<ResultDto> {
    try {
      const response = await api.get(`remessas/update-status/${id}/${status}`,
        {
          timeout: 0,
        });

      return response.data as ResultDto;
    } catch (error) {
      console.error("Erro ao buscar as remessas::", error);
      return { message: "", success: false };
    }
  }

  static async cancelRemittance(
    id: number,
    status: StatusRemessa.CANCELADO | StatusRemessa.RECUSADA | StatusRemessa.ERRO
  ): Promise<ResultDto> {
    try {
      const response = await api.get(`remessas/cancel-remittance/${id}/${status}`,
        {
          timeout: 0,
        });
      return response.data as ResultDto;
    } catch (error) {
      console.error("Erro ao buscar as remessas::", error);
      return { message: "", success: false };
    }
  }
}

export default RemessasService;
